module.exports = __webpack_public_path__ + "static/media/medium.e35d2a9e.png";